import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { DBConnectorService } from './test.service';

@Injectable()

export class LogService {
    constructor(private http: HttpClient,
        private dbconnectorservice: DBConnectorService) { }

    fetchLogs(source: string, user: string) {
        const url = '/api/RealTimelogs/get_logs_training' + '?userName=' + user + '&userAction=' + source
        // const resource = this.adalService.GetResourceForEndpoint(url);
        const options = {
            headers: new HttpHeaders({
                // 'Authorization': 'Bearer ' + this.adalService.getCachedToken(resource),
                'UserName': this.dbconnectorservice.username,
                'IpAddress': this.dbconnectorservice.ipaddress
            })
        }
        return this.http.get<any>(url, options)
    }
}